<template>
  <div class="awards-top-section__winners-btn-wrapper">
    <a-visibility :hide="true" :on="[$breakpoint.mobile]">
      <a-view-winners-button class="awards-top-section__winners-btn">
        View the winners
      </a-view-winners-button>
    </a-visibility>

    <a-visibility :show="true" :on="[$breakpoint.mobile]">
      <a-view-winners-button
        :border-radius-small="true"
        class="awards-top-section__winners-btn"
      >
        View the winners
      </a-view-winners-button>
    </a-visibility>
  </div>
</template>

<script>
import AViewWinnersButton from 'sections/_voting/shared/AViewWinnersButton'

export default {
  name: 'AwardsTopSectionWinnersButton',
  components: { AViewWinnersButton }
}
</script>

<style lang="scss" scoped>
.awards-top-section__winners-btn-wrapper {
  display: flex;
  position: relative;
  z-index: 1;

  .awards-top-section__winners-btn {
    display: flex;
    margin: 32px auto;
    background-color: $c--black;

    $padding: (
      $above-desktop-xl: 25px 50px,
      $mobile: 13px 50px
    );

    @include setStyleByBreakpoint('padding', $padding);
  }
}
</style>
